
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/join-us/register",
      function () {
        return require("private-next-pages/join-us/register/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/join-us/register"])
      });
    }
  